import axios from 'axios';
import { tokenConfig } from './authActions';
import store from '../store';

export const getDocument = async (fileName: string) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/documents', {...tokenConfig(store.getState), params: {fileName}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getDocument", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const getAvailableDocuments = async (venteId: number) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/documents/available_documents', {...tokenConfig(store.getState), params: {venteId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getAvailableDocuments", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    });
  });
};

export const addDocument = async (type: string, venteId: number, comment: string, userId: number | undefined, userName: string | undefined, upload: any) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .post('/api/documents', { type, venteId, comment, userId, userName, upload }, tokenConfig(store.getState))
    .then(res => 
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getDocument", err)
    });
  });
};

